











































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import ICompanyExciseTariffSet from '@/store/models/ICompanyExciseTariffSet';
import ICompanyExciseTariffLine from '@/store/models/ICompanyExciseTariffLine';
import IListExciseDrinkCategory from '@/store/models/IListExciseDrinkCategory';
import { ExciseRateType } from '@/components/Enums/ExciseRateType';
import CompanyExciseTariffSetsApi from '@/store/api/CompanyExciseTariffSetsApi';
import CompanyExciseTariffLinesApi from '@/store/api/CompanyExciseTariffLinesApi';
import ListExciseDrinkCategoriesApi from '@/store/api/ListExciseDrinkCategoriesApi';

@Component
export default class ExciseTariffManager extends Vue {
    @Prop({ type: String, required: true })
    companyId!: string;

    tariffSets: ICompanyExciseTariffSet[] = [];
    tariffLines: ICompanyExciseTariffLine[] = [];
    exciseCategories: IListExciseDrinkCategory[] = [];

    selectedTariffSet: ICompanyExciseTariffSet | null = null;

    dialogTariffSet: boolean = false;
    dialogTariffLine: boolean = false;

    editedTariffSetIndex: number = -1;
    editedTariffLineIndex: number = -1;

    editedTariffSet: ICompanyExciseTariffSet = {
        id: "",
        idCompany: "",
        name: "",
        validFrom: new Date(),
        validTo: null,
        isActive: true
    };

    defaultTariffSet: ICompanyExciseTariffSet = {
        id: "",
        idCompany: "",
        name: "",
        validFrom: new Date(),
        validTo: null,
        isActive: true
    };

    editedTariffLine: ICompanyExciseTariffLine = {
        id: "",
        idTariffSet: "",
        idExciseDrinkCategory: "",
        DrinkCategoryName: "",
        alcoholFrom: 0,
        alcoholTo: 0,
        rateType: ExciseRateType.PerLiter,
        rateAmount: 0,
        customsCode: ""
    };

    defaultTariffLine: ICompanyExciseTariffLine = {
        id: "",
        idTariffSet: "",
        idExciseDrinkCategory: "",
        DrinkCategoryName: "",
        alcoholFrom: 0,
        alcoholTo: 0,
        rateType: ExciseRateType.PerLiter,
        rateAmount: 0,
        customsCode: ""
    };

    dialogDelete: boolean = false;
    deleteType: 'tariffSet' | 'tariffLine' = 'tariffSet';
    deleteTargetId: string = '';

    dialogActivate: boolean = false;

    lineHeaders: any[] = [
        { text: 'Drink Category', value: 'idExciseDrinkCategory' },
        { text: 'Alcohol From', value: 'alcoholFrom' },
        { text: 'Alcohol To', value: 'alcoholTo' },
        { text: 'Rate Type', value: 'rateType' },
        { text: 'Rate Amount', value: 'rateAmount' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];

    rateTypes = Object.values(ExciseRateType);

    get drinkCategories(): string[] {
        return this.exciseCategories.map(c => c.name);
    }

    getDrinkCategoryName(idDrinkCategory: string): string {
        const category = this.exciseCategories.find(c => c.id === idDrinkCategory);
        return category ? category.name : idDrinkCategory;
    }

    get tariffLinesFiltered(): ICompanyExciseTariffLine[] {
        if (!this.selectedTariffSet) return [];
        return this.tariffLines.filter(t => t.idTariffSet === this.selectedTariffSet!.id);
    }

    get tariffSetFormTitle() {
        return this.editedTariffSetIndex === -1 ? 'New Tariff Set' : 'Edit Tariff Set';
    }

    get tariffLineFormTitle() {
        return this.editedTariffLineIndex === -1 ? 'New Tariff Line' : 'Edit Tariff Line';
    }

    get currentActiveTariffSet(): ICompanyExciseTariffSet | undefined {
        return this.tariffSets.find(t => t.isActive);
    }

    get currentActiveTariffName(): string {
        const active = this.currentActiveTariffSet;
        return active ? active.name : '';
    }

    async mounted() {
        await this.loadData();
    }

    async loadData() {
        // Aquí luego cargas APIs reales
        const tariffSetApi = new CompanyExciseTariffSetsApi();
        const tariffLineApi = new CompanyExciseTariffLinesApi();
        const exciseCategoriesApi = new ListExciseDrinkCategoriesApi();
        this.tariffSets = await tariffSetApi.GetCompanyExciseTariffSetsByCompany(this.companyId);
        this.tariffLines = await tariffLineApi.GetCompanyExciseTariffLines();
        this.exciseCategories = await exciseCategoriesApi.GetListExciseDrinkCategories();

        const activeSet = this.tariffSets.find(t => t.isActive);
        if (activeSet) {
            this.selectedTariffSet = activeSet;
        }
    }

    openNewTariffSetDialog() {
        const hasActive = this.tariffSets.some(t => t.isActive);
        this.editedTariffSetIndex = -1;
        this.editedTariffSet = Object.assign({}, this.defaultTariffSet, {
            idCompany: this.companyId,
            isActive: !hasActive
        });
        this.dialogTariffSet = true;
    }

    closeTariffSetDialog() {
        this.dialogTariffSet = false;
        this.$nextTick(() => {
            this.editedTariffSet = Object.assign({}, this.defaultTariffSet);
            this.editedTariffSetIndex = -1;
        });
    }

    openEditTariffSetDialog() {
        if (!this.selectedTariffSet) return;
        this.editedTariffSetIndex = this.tariffSets.findIndex(t => t.id === this.selectedTariffSet!.id);
        this.editedTariffSet = Object.assign({}, this.selectedTariffSet);
        this.dialogTariffSet = true;
    }

    async saveTariffSet() {
        // Check if activating this set would conflict with an existing active set
        const currentActive = this.currentActiveTariffSet;
        if (this.editedTariffSet.isActive && currentActive && currentActive.id !== this.editedTariffSet.id) {
            this.dialogActivate = true;
            return;
        }
        await this.executeSaveTariffSet();
    }

    cancelActivation() {
        this.dialogActivate = false;
        this.editedTariffSet.isActive = false;
    }

    async confirmActivation() {
        this.dialogActivate = false;
        await this.deactivateCurrentActive();
        await this.executeSaveTariffSet();
    }

    async deactivateCurrentActive() {
        const currentActive = this.currentActiveTariffSet;
        if (!currentActive) return;

        const tariffSetApi = new CompanyExciseTariffSetsApi();
        const updatedSet = Object.assign({}, currentActive, { isActive: false });
        const success = await tariffSetApi.UpdateCompanyExciseTariffSet(updatedSet);
        if (success) {
            const idx = this.tariffSets.findIndex(t => t.id === currentActive.id);
            if (idx !== -1) {
                this.tariffSets[idx].isActive = false;
            }
            if (this.selectedTariffSet && this.selectedTariffSet.id === currentActive.id) {
                this.selectedTariffSet = Object.assign({}, this.tariffSets[idx]);
            }
        }
    }

    async executeSaveTariffSet() {
        const tariffSetApi = new CompanyExciseTariffSetsApi();
        if (this.editedTariffSetIndex === -1) {
            const newId = await tariffSetApi.SaveCompanyExciseTariffSet(this.editedTariffSet);
            if (newId) {
                this.editedTariffSet.id = newId;
                this.tariffSets.push(Object.assign({}, this.editedTariffSet));
            }
        } else {
            const success = await tariffSetApi.UpdateCompanyExciseTariffSet(this.editedTariffSet);
            if (success) {
                Object.assign(this.tariffSets[this.editedTariffSetIndex], this.editedTariffSet);
                if (this.selectedTariffSet && this.selectedTariffSet.id === this.editedTariffSet.id) {
                    this.selectedTariffSet = Object.assign({}, this.editedTariffSet);
                }
            }
        }
        this.closeTariffSetDialog();
    }

    confirmDeleteTariffSet() {
        if (!this.selectedTariffSet) return;
        this.deleteType = 'tariffSet';
        this.deleteTargetId = this.selectedTariffSet.id;
        this.dialogDelete = true;
    }

    openNewTariffLineDialog() {
        if (!this.selectedTariffSet) return;

        this.editedTariffLineIndex = -1;
        this.editedTariffLine = Object.assign({}, this.defaultTariffLine, {
            idTariffSet: this.selectedTariffSet.id,
            idExciseDrinkCategory: this.exciseCategories.length > 0 ? this.exciseCategories[0].id : ""
        });
        this.dialogTariffLine = true;
    }

    closeTariffLineDialog() {
        this.dialogTariffLine = false;
        this.$nextTick(() => {
            this.editedTariffLine = Object.assign({}, this.defaultTariffLine);
            this.editedTariffLineIndex = -1;
        });
    }

    openEditTariffLineDialog(item: ICompanyExciseTariffLine) {
        this.editedTariffLineIndex = this.tariffLines.findIndex(t => t.id === item.id);
        this.editedTariffLine = Object.assign({}, item);
        this.dialogTariffLine = true;
    }

    async saveTariffLine() {
        const tariffLineApi = new CompanyExciseTariffLinesApi();
        if (this.editedTariffLineIndex === -1) {
            const newId = await tariffLineApi.SaveCompanyExciseTariffLine(this.editedTariffLine);
            if (newId) {
                this.editedTariffLine.id = newId;
                this.tariffLines.push(Object.assign({}, this.editedTariffLine));
            }
        } else {
            const success = await tariffLineApi.UpdateCompanyExciseTariffLine(this.editedTariffLine);
            if (success) {
                Object.assign(this.tariffLines[this.editedTariffLineIndex], this.editedTariffLine);
            }
        }
        this.closeTariffLineDialog();
    }

    confirmDeleteTariffLine(item: ICompanyExciseTariffLine) {
        this.deleteType = 'tariffLine';
        this.deleteTargetId = item.id;
        this.dialogDelete = true;
    }

    async executeDelete() {
        if (this.deleteType === 'tariffSet') {
            const tariffSetApi = new CompanyExciseTariffSetsApi();
            const success = await tariffSetApi.DeleteCompanyExciseTariffSet(this.deleteTargetId);
            if (success) {
                this.tariffSets = this.tariffSets.filter(t => t.id !== this.deleteTargetId);
                this.tariffLines = this.tariffLines.filter(t => t.idTariffSet !== this.deleteTargetId);
                this.selectedTariffSet = null;
            }
        } else {
            const tariffLineApi = new CompanyExciseTariffLinesApi();
            const success = await tariffLineApi.DeleteCompanyExciseTariffLine(this.deleteTargetId);
            if (success) {
                this.tariffLines = this.tariffLines.filter(t => t.id !== this.deleteTargetId);
            }
        }
        this.dialogDelete = false;
    }
}
